import React from "react";
import { Chip, PaletteColor, useTheme } from "@mui/material";
import { AttendanceStatus } from "../../../types/Event";
import _ from "lodash";

export default function AttendancePill({ status }: { status: AttendanceStatus | null }) {
  const theme = useTheme();
  const colorMap: Record<AttendanceStatus, PaletteColor> = {
    'pending': theme.palette.warning,
    'accepted': theme.palette.success,
    'declined': theme.palette.error,
  };

  if (!status) return '-';

  return (
    <Chip label={_.startCase(status)} sx={{ bgcolor: colorMap[status].light }} size='small' />
  );
}